import { ContentLayout } from 'components/layouts/ContentLayout';
import { SecondaryNav } from 'components/navigation/SecondaryNav';
import { fetchRecipe, selectRecipeById } from 'features/recipes/store/recipesSlice';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { RecipeGantt } from '../components/RecipeGantt';
import Backdrop from '@mui/material/Backdrop';
import { useSnackbar } from 'notistack';

import CircularProgress from '@mui/material/CircularProgress';


export const Recipe = () => {
  const dispatch = useDispatch();
  const { recipeId } = useParams();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);
  const recipeName = useSelector((state) => selectRecipeById(state, recipeId)?.name);

  useEffect(() => {
    dispatch(fetchRecipe({ recipeId })).unwrap()
      .then(() => setLoading(false))
      .catch((error) => {
        if (error.includes("No query results for model")) {
          enqueueSnackbar('Recipe not found.', { variant: 'error' });
        }
        setLoading(false)
        navigate('/');
      });
  });
  return (
    <ContentLayout header={<SecondaryNav title={recipeName} />}>
      {loading ?
        <Backdrop open={true} style={{ zIndex: 13 }} sx={{ color: '#fff' }}>
          <CircularProgress className="loading" />
        </Backdrop> :
        <RecipeGantt recipeId={recipeId}></RecipeGantt>}
    </ContentLayout>
  );
};